// Nines — ported verbatim from GolfGamesScorecard's calcNines (utils/scoring.ts).
// 3 players, 9 points distributed per hole: outright low 5, second 3, third 1;
// two tied for low 4/4/1; all three tied 3/3/3. Ranked by total, high first.
export function calcNines(players) {
  return (players || [])
    .map((p) => {
      const points = p.scores.map((_, hole) => {
        const triple = players.map((pp) => pp.scores[hole])
        if (triple.some((s) => s === null || s === undefined)) return 0
        const mine = p.scores[hole]
        const lower = triple.filter((s) => s < mine).length
        const equal = triple.filter((s) => s === mine).length
        if (lower === 0 && equal === 1) return 5 // outright low
        if (lower === 0 && equal === 2) return 4 // tied for low
        if (lower === 0 && equal === 3) return 3 // three-way tie
        if (lower === 1 && equal === 1) return 3 // outright second
        if (lower === 1 && equal === 2) return 2 // tied for second
        if (lower === 2) return 1 // third
        return 0
      })
      return { ...p, points, total: points.reduce((s, v) => s + v, 0) }
    })
    .sort((a, b) => b.total - a.total)
}
